import '../css'

$(document).on('change', '#author_user_id', function() {
  let option = $('#author_user_id option:selected')
  $('#author_name').val(option.text())
  $('#author_email').val(option.attr('data-email'))
})
